import { DROPDOWN_SELECT_CURRENT_REQUEST } from "../../../enums/Request/currentRequestControls.types";

export const dropdownSelectionCurrentRequest = ({ event, element, stateProperty, indexOfArray, arrField }) => {
    return {
        type: DROPDOWN_SELECT_CURRENT_REQUEST,
        payload: { event, element, stateProperty, indexOfArray, arrField },
    };
};
